"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./AdminApi"));
__export(require("./AdyenIntegrationApi"));
__export(require("./AppointmentEnquiriesApi"));
__export(require("./AppointmentTypesApi"));
__export(require("./AreaBookingTypesApi"));
__export(require("./AvailabilityApi"));
__export(require("./BrandsApi"));
__export(require("./CustomersApi"));
__export(require("./DepositExposureApi"));
__export(require("./DepositLedgerApi"));
__export(require("./DiscountTypesApi"));
__export(require("./DiscountUsageApi"));
__export(require("./EscPosConnectorsApi"));
__export(require("./FiscalisationApi"));
__export(require("./FiskaltrustApi"));
__export(require("./GantnerApi"));
__export(require("./HConnectIntegrationApi"));
__export(require("./ImportsApi"));
__export(require("./IntegrationConfigsApi"));
__export(require("./InventoryBrandsApi"));
__export(require("./InventoryCategoriesApi"));
__export(require("./LedgerLinePostingsApi"));
__export(require("./LedgerLinesApi"));
__export(require("./MarketingPreferencesApi"));
__export(require("./MediaApi"));
__export(require("./MembershipChargesApi"));
__export(require("./MembershipRatesApi"));
__export(require("./MembershipTypesApi"));
__export(require("./MembershipsApi"));
__export(require("./MetaApi"));
__export(require("./OfferingAvailabilityApi"));
__export(require("./OnboardingApi"));
__export(require("./OrdersApi"));
__export(require("./OrganisationReportsApi"));
__export(require("./OvernightsApi"));
__export(require("./PMSApi"));
__export(require("./PackagesApi"));
__export(require("./PermissionsApi"));
__export(require("./PremierCoreMappingsApi"));
__export(require("./ProductsApi"));
__export(require("./ReportsApi"));
__export(require("./RevenueCentresApi"));
__export(require("./SessionTypesApi"));
__export(require("./SitesApi"));
__export(require("./SmsFragmentsApi"));
__export(require("./SmsUsageApi"));
__export(require("./SuppliersApi"));
__export(require("./TableReservationTypesApi"));
__export(require("./TaxConfigurationsApi"));
__export(require("./UsersApi"));
__export(require("./VisitTypeApi"));
__export(require("./VisitsApi"));
__export(require("./VoucherLedgerApi"));
